(() => {
  const connect = (root = document) => {
    root.querySelectorAll('header-menu').forEach((menu) => {
      if (menu.dataset.freelifeReady === 'true') return;
      menu.dataset.freelifeReady = 'true';
      const details = menu.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (!details || !summary) return;
      let closeTimer;
      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      const open = () => {
        if (!finePointer.matches) return;
        window.clearTimeout(closeTimer);
        document.querySelectorAll('header-menu > details[open]').forEach((other) => {
          if (other !== details) { other.removeAttribute('open'); other.querySelector('summary')?.setAttribute('aria-expanded', 'false'); }
        });
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };
      const close = () => {
        closeTimer = window.setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) { details.removeAttribute('open'); summary.setAttribute('aria-expanded', 'false'); }
        }, 160);
      };
      menu.addEventListener('pointerenter', open);
      menu.addEventListener('pointerleave', close);
      menu.addEventListener('focusin', open);
      menu.addEventListener('focusout', close);
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) { details.removeAttribute('open'); summary.setAttribute('aria-expanded', 'false'); summary.focus(); }
      });
    });
  };
  connect();
  document.addEventListener('shopify:section:load', (event) => connect(event.target));
})();
